import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Typography } from "@mui/material";
import { useCallback, useState } from "react";
import PaperDraggable from "../../../../../../../../components/PaperDraggable";

export default function TiposPublicos({
    open,
    defaultValue,
    onClose,
    onSubmitFiltros,
}: TiposPublicosProps) {

    const [selecionados, setSelecionados] = useState<TSelecionados[]>(defaultValue);

    const dataContent: TTipoPublico[] = [
        { label: "Associado", value: "A" },
        { label: "Fornecedor", value: "F" },
        { label: "Cliente", value: "C" },
        { label: "Empregado", value: "E" },
        { label: "Loja", value: "L" },
    ]

    const handleClick = useCallback((item: string) => {
        const index = selecionados.findIndex(i => i === item);
        if (index === -1) {
            setSelecionados(prevState => [...prevState, item]);
        } else {
            setSelecionados(prevState => prevState.filter((_, i) => i !== index));
        }
    }, [selecionados]);

    const handleSubmit = useCallback(() => {
        onSubmitFiltros(selecionados);
        onClose();
    }, [selecionados, onClose, onSubmitFiltros]);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={'xs'}
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            fullWidth
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Tipos público</DialogTitle>
            <DialogContent>
                <Box display={'flex'} flexDirection={'column'}>
                    {
                        (dataContent && dataContent.length > 0) && dataContent.map((i, index) => {
                            const isChecked = selecionados.some((item) => item === i.value);
                            return (
                                <FormControlLabel
                                    key={index}
                                    onChange={() => handleClick(i.value)}
                                    control={<Checkbox checked={isChecked} />}
                                    sx={{ mb: 0 }}
                                    label={
                                        <Box>
                                            <Typography>{`${i.label}`}</Typography>
                                        </Box>
                                    }
                                />
                            );
                        })
                    }
                </Box>
            </DialogContent>
            <DialogActions>
                <Box display={'flex'} gap={2}>
                    <Button variant="outlined" onClick={onClose}>
                        Fechar
                    </Button>
                    <Button variant="contained" color="primary" onClick={handleSubmit}>
                        Selecionar
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    )
}

interface TiposPublicosProps {
    open: boolean
    defaultValue: Array<"A"|"F"|"C"|"E"|"L"> | []
    onClose: () => void
    onSubmitFiltros: (value: any) => void
}

type TTipoPublico = {
    label: string
    value: string
}
type TSelecionados = string
